const suggestionsList = [{
  value: 'IND',
  text: 'India'
}, {
  value: 'CHI',
  text: 'China'
}, {
  value: 'NEP',
  text: 'Nepal'
}, {
  value: 'PHI',
  text: 'Philippines'
}, {
  value: 'PAK',
  text: 'Pakistan'
}];
export default suggestionsList;